import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./assetClassDistributionActions";
import * as request from "utility/request";
import { AssetClass } from "types/AssetClass";
import { AssetClassDistribution } from "types/AssetClassDistribution";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadAssetClassDistribution = (
  reportControlId: string,
  reportDate: string
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all"));

    try {
      const res = await request.getResponseJson<AssetClassDistribution[]>(
        `${apiUrl}/api/assetClassDistribution?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess("all", res));
    } catch (error) {
      return request.handleFetchError(
        dispatch,
        error as string,
        loadFail("all", error as string)
      );
    }
  };
};

export const loadAssetClassDistributionByAssetClass = (
  assetClass: AssetClass,
  reportControlId: string,
  reportDate: string
) => {
  const assetClassString = AssetClass[assetClass] as keyof typeof AssetClass;
  return async (dispatch: RootDispatch) => {
    dispatch(load(assetClassString));

    try {
      const res = await request.getResponseJson<AssetClassDistribution[]>(
        `${apiUrl}/api/assetClassDistribution/${assetClass}?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess(assetClassString, res));
    } catch (error) {
      return request.handleFetchError(
        dispatch,
        error as string,
        loadFail(assetClassString, error as string)
      );
    }
  };
};
